// 中文(Chinese)
export default {
  oneOneClass: "{course}外教1v1",
  learnPracEnFast: "实用{language}开口说",
  htOralClass: "HelloTalk口语课",
  benefits: "4大优势",
  topicNumber: "800+互动主题",
  dailyBusinessAcademic: "涵盖商务/留学/生活场景/{test name}",
  englishTutors: "涵盖商务/留学/生活场景/{test name}",
  qualifiedTutors: "资深外教1对1",
  nativeOkAllAges: "严选{course}外教，定期考核",
  oneOneLive: "直播互动教学",
  accessToRecord: "视频授课，课后无限回放",
  personalizedPlan: "量身定制学习方案",
  ensureGoal: "精准定位，1v1私人定制",
  professional: "专业",
  nativeTeam: "外教团队",
  authenticLanguage: "提供纯正地道{language}课堂",
  bgChecked: "高师资",
  experiencedTeachers: "严选拥有丰富线上教学经验的母语外教老师",
  assuredQuality: "严把控",
  regularAssess: "多轮培训考核录用、全程监督、定期考核",
  assuredSatisfaction: "重体验",
  teamSizeAndRefund: "重体验",
  curriculum: "课程设置",
  dailyTalks: "生活口语",
  beginnerInfo: "初级Level 1 - 40课时",
  lessonOverview: "课程概览",
  beginnerClassIntro:
    "真实再现生活情境，以角色扮演和情景学习等形式，帮助学生快速掌握生活场景中的基本句型和表达，实现开口说。",
  topicEx: "话题实例",
  beginnerTopicEx: "自我介绍、就餐与点餐、兴趣爱好",
  mediateInfo: "中级Level 2-3 - 80课时",
  mediateClassIntro:
    "涵盖80个日常对话中高频话题，达到对事件的基本描述与观点的简单阐述，达到听得懂有得说。",
  mediateTopicEx: "指路问路、寻医问诊、观点表达",
  advancedInfo: "高级Level 2-3 - 80课时",
  advancedClassIntro:
    "真实场景对话模拟，甄选时事热点话题进行深度讨论，实现英语流利表达自己思想观点。",
  advancedTopicEx: "租房买房、聚会邀约、旅游英语",
  businessLanguage: "商务{language}",
  busElementInfo: "初级Level 1-2 - 40课时",
  busElementClassIntro:
    "由浅入深教授商务{language}，帮助学生收获外企敲门砖，快速融入国际化企业工作状态",
  busElementTopicEx: "简历准备、求职面试、初入职场",
  busMediateInfo: "中级Level 3-4 - 40课时",
  busMediateClassIntro: "中级Level 3-4 - 40课时",
  busMediateTopicEx: "合同签订、商务谈判、国际贸易",
  ielts: "雅思实战",
  languageTests: "等级考试",
  aHundredLessons: "100课时",
  ieltsClassIntro:
    "甄选{test name}高频话题，快速提升流利度与连贯性，形成{language}思维， 打破瓶颈快速提分。",
  faq: "你关心的",
  questionCn: "问题",
  classLength: "Q1 每节课课程时长是多少？",
  classInfoAndSuggest:
    "A1 试听课为25分钟一节。针对基础较弱的同学，我们建议每课30分钟以达到更好的场景训练效果；对于有一定基础，有较强口语练习或考试需求的同学，我们建议每节课45分钟来快速提高。",
  lessonForm: "Q2 外教直播课形式如何，是否可以回放？",
  lessonFormInfo:
    "A2我们采用一对一视频在线课堂，课上和老师根据材料进行情景会话训练，课后还可以观看课程回放进行复习哦。",
  lessonPrepare: "Q3 上课前我应该准备什么？",
  lessonPrepareInfo:
    "A3 一对一课程为在线视频课程，我们建议您使用平板/电脑上课效果最佳，请在上课前确保自己处于稳定的网络环境中哦。",
  support: "咨询",
  limitedOffer: "限时特惠",
  originalPrice: "原价",
  bookNow: "立即抢购试听",
  successPurchase: "你已成功购买试听！",
  trialEndAndGoOn:
    "试听完成后，你可按照月度/季度进行续费学习，持续养成良好的学习习惯～",
  courseAdvisor: "咨询课程顾问",
  oneLastStep: "只差最后一步啦",
  ticketPrice: "一张电影票的价格就可以提高你的{language}口语能力～",
  perPriceAndOrder: "{price}/次，去预定",
  noThanks: "不了，看看再说",
  unpaidAndProceed: "{language}1对1抢鲜试听订单还未支付，点击继续",
  halfPrice: "5折抢购{course}外教口语课",
  languageEn: "英语",
  languageKo: "韩语",
  languageEsp: "西班牙语",
  languageFr: "法语",
  languageIt: "意大利语",
  languageRu: "俄罗斯语",
  languageCn: "中文",
  languageJp: "日语",
  courseEn: "英美",
  courseKo: "韩语",
  courseEsp: "西班牙语",
  courseFr: "法语",
  courseIt: "意大利语",
  courseRu: "俄罗斯语",
  courseCn: "中文",
  courseJp: "日语",
  enTestEn: "IELTS",
  koTestEn: "TOPIK",
  espTestEn: "DELE",
  frTestEn: "DELF/DEAL/TE",
  itTestEn: "CILS",
  ruTestEn: "ТРКИ",
  jpTestEn: "JLPT",
  cnTestEn: "HSK",
  jpPrivateClassCn: "1v1私教课",
  jpPracticalCn: "实用日语课",
  jpOfficialAutoCn: "官方标准自研课程",
  jpClassSystemCn: "完整的自研课程体系，270+活动场景",
  jpIdeaCn: "实用日语教学理念",
  jpEmphasisCn: "注重应用场景活动能力的Output",
  jpTutorTimeCn: "外教/时间自由选",
  jpTutorTimeChooseCn: "根据需求，自由选择外教和时间",
  jpAccessToRecordCn: "在线1v1视频授课，课后无限回放",
  jpGoodLookCn: "高颜值",
  jpNativeTeamCn: "资深外教团队",
  jpOnlineCn: "1v1在线教学",
  jpBgCheckedCn: "优师资",
  jpTutorTrainCn: "日本文化厅420H培训，多年线上教学经验",
  jpStrictScreenCn: "层层选拔录用、定期培训和考核、全程监督",
  jpImproveCn: "优质外教助你日语开口说，提升日语综合能力",
  jpHtPracticalCn: "HelloTalk实用日语课设置",
  jpBeginnerClassIntroCn:
    "以角色扮演、情景演绎的形式再现生活场景，帮助学生快速地实现用日语简单地表达自身相关需求。",
  settingEx: "场景实例",
  jpBeginnerExCn: "自我介绍、询问价格、兴趣爱好",
  jpMediateInfoCn: "中级Level 2-3 - 60课时",
  jpMediateClassIntroCn:
    "包含 60 个日常高频场景，实现用 简练的日语来描述身边情况及日常行为，并且对可预测的日常情况 做出基本应对。",
  jpMediateExCn: "受伤看病、描述事件、表达观点",
  jpAdvancedInfoCn: "高级Level 4 - 30课时",
  jpAdvancedClassIntroCn:
    "甄选生活、旅游、工作等场景, 实现用日语表达基本生活用语， 能够就相关情况进行说明。",
  jpAdvancedExCn: "看音乐会、赠送礼物、寻找失物",
  jpBusinessCn: "职场商务",
  jpBusElementInfoCn: "初级Level 1-2 - 60课时",
  jpBusElementClassIntroCn:
    "结合不同场景，由浅入深，实现通过复杂的文章构造，组织语言阐明自己的观点及议论的框架。",
  jpBusElementExCn: "请假早退、面试礼仪、产品故障",
  jpBusAdvancedInfoCn: "高级Level 3 - 30课时",
  jpBusAdvancedClassIntroCn:
    "还原商务活动的真实场景，以角色扮演的形式再现工作场景，实现用恰当的敬语来准确表达自己的想法。",
  jpBusAdvancedExCn: "工作汇报、指出错误、抱怨加班",
  jpSmoothTalkCn: "无障碍沟通",
  jpSixtyLessonsCn: "60课时",
  jpSmoothClassIntroCn:
    "结合职场、经济、文化等不同场景，能够选择最合适的语言准确表达自己的看法，熟练使用各种表达方式。",
  jpClassInfoSuggestCn:
    "A1 试听课是 25 分钟。常规课是每节课 45 分钟。真人在线 1V1 视频授课，课后还可以观 看课程回放。",
  jpClassTimeCn:
    "A2 我们的外教老师大都居住在日本，上课时间一般为平时的晚上19点-23点(北京时间) 以及周末。购买课程后，我们会尽量根据您的时间、您喜欢的外教进行排课。",
  jpLessonPrepareInfoCn:
    "A3 由于是线上课，请在上课前确保自己处于稳定的网络环境中哦。另外，建议您用平板/ 电脑上课效果最佳。",
  jpLimitedOfferCn: "限时特惠 ¥59.9",

  coinSpecialOffer: "HT币充值优惠",
  buySomeAndGetExtra: "购买即获得额外赠送",
  balance: "余额",
  coins: "{number}HT币",
  coin: "{number}HT币",
  extraCoins: "再送{number}",
  continue: "继续",
  byToppingUpYouAgree: "购买即代表同意",
  topUpAgreement: "《充值协议》",
  htCoin: "HT币",
  scanCodeToLog: "扫码登录",
  bindYourHelloTalkAccount: "用HelloTalk APP 扫码登录，绑定账号后进行充值",
  itemSelection: "套餐选择",
  paymentAmount: "支付金额",
  topUpSuccessful: "充值成功",
  totalCoinsNumber:
    "你已成功充值{numberone}，并额外获得{numbertwo}赠送，总计{numberall}",
  ok: "OK",
  payMethods: "使用支付宝&微信扫码支付",
  alipay: "支付宝",
  weChatPay: "微信支付",
  copyLinkToPay: "请复制链接到HelloTalk APP内完成支付",
  paymentFailed: "支付失败",
  creditCardPay: "使用PayPal&信用卡支付",
  creditCard: "信用卡",
  payssion: {
    // key:value
    purchaseSucceeded: "购买成功",
    topUpSuccessful: "充值成功👏",
    paymentFailed: "支付失败",
    recharge: "充值",
    VipRecharge: "VIP充值",
    rechargeWithCoins: "HT币充值",
    oneMonthMember: "一个月会员",
    annualFeeMember: "年费会员",
    oneTimePurchase: "终身会员",
    coins: "{number} HT币",
    coin: "{number} HT币",
    extraCoins: "再送{number}",
    extraCoin: "再送{number}",
    continue: "继续",
    byToppingUpYouAgree: "购买即代表同意",
    rechargePrompt: "温馨提示:未成年人请在监护人的陪同下或许可下操作",
    toppingUpYouAgree: "《充值协议》",
  },
  //
};
